export default __webpack_public_path__ + "locales/uk-UA/FormFillingTipsDialog.json?hash=f866b0b433e12405e4602ee767c297c9";